<template>
    <div>
        <section class="section sec6" v-if="!isWebView">
            <div class="inner">
                <div class="txtbox">
                    <img :src="`${$STATIC_URL}/user/img/logo.png`" alt="" class="logo">
                    <p class="m_txt2 center">
                        커피 1잔 값으로 매달 당첨가능성이 높은 번호를 제공해드립니다. <br>
                        Plan 업그레이드는 앱설치가 필요합니다.
                    </p>
                </div>
                <div class="btnbox">
                    <button type="button" class="btn ver3" @click="goToGooglePlay">
                        <img :src="`${$STATIC_URL}/user/img/ico_googleplay.png`" alt="" class="icon">
                        <span class="txt">Google Play</span>
                    </button>
                    <button type="button" class="btn ver3" @click="goToAppStore">
                        <img :src="`${$STATIC_URL}/user/img/ico_appstore.png`" alt="" class="icon">
                        <span class="txt">App Store</span>
                    </button>
                </div>
                <img :src="`${$STATIC_URL}/user/img/phone_preview.png`" alt="" class="phone_preview">
            </div>
        </section>
        <section class="section sec6" v-else>
            <div class="inner">
                <div class="txtbox">
                    <img :src="`${$STATIC_URL}/user/img/logo.png`" alt="" class="logo">
                    <p class="m_txt2 center">
                            커피 1잔 값으로 매달 당첨가능성이 높은 번호를 제공해드립니다. <br>
                            Plan 업그레이드는 앱설치가 필요합니다.
                        </p>
                    </div>
                    <div class="btnbox">
                        <button type="button" class="btn ver3 plan_btn">
                            Plan 업그레이드
                        </button>
                    </div>
                    <img :src="`${$STATIC_URL}/user/img/phone_preview.png`" alt="" class="phone_preview">
                </div>
            </section>
    </div>
</template>

<script setup>
import { ref } from 'vue';
const userAgent = navigator.userAgent;
let isWebView = ref(false);
if (userAgent.includes("WebView")) {
    isWebView.value = true;
} else {
    isWebView.value = false;
}

const goToGooglePlay = () => {
    window.open('https://play.google.com/store/apps/details?id=io.numberfavored.app', '_blank');
}

const goToAppStore = () => {
    window.open('https://apps.apple.com/kr/app/number-favored/id6743689842', '_blank');
}
</script>


<style></style>